/* eslint-disable no-restricted-globals */
export default {
  props: {
    fsCcAttrs: String,
  },
  computed: {
    parseAttributeString() {
      const attributes = {};
      if (this.fsCcAttrs) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = `<div ${this.fsCcAttrs.trim(' ')}></div>`;
        [...wrapper.firstChild.attributes].forEach((attr) => {
          attributes[attr.name] = attr.value;
        });
      }
      return attributes;
    },
  },
  watch: {
    fsCcAttrs() {
      // component doesn't change, but the slide does (e.g. second question)
      this.$nextTick(() => {
        if (top?.WE_API) {
          top.WE_API.Preview.rescan();
        }
      });
    },
  },
  mounted() {
    // first time the component is mounted (e.g. first question)
    this.$nextTick(() => {
      if (top?.WE_API) {
        top.WE_API.Preview.rescan();
      }
    });
  },
};
